import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex md:flex-col items-center gap-4" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "flex md:flex-col gap-2 items-center" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["disabled"]




export default /*@__PURE__*/_defineComponent({
  __name: 'CarouselControls',
  props: {
    currentIndex: {},
    total: {}
  },
  emits: ["prev", "next", "select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('prev'))),
      disabled: props.currentIndex === 0,
      class: _normalizeClass(["group transition-opacity rounded-full hidden md:block", 
        props.currentIndex === 0
          ? 'opacity-40 cursor-not-allowed'
          : 'opacity-100'
      ])
    }, [...(_cache[2] || (_cache[2] = [
      _createElementVNode("svg", {
        width: "56",
        height: "56",
        viewBox: "0 0 56 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        class: "transition-colors duration-300 ease-in-out"
      }, [
        _createElementVNode("circle", {
          cx: "28",
          cy: "28",
          r: "27.5",
          class: "stroke-white transition-colors duration-300 ease-in-out group-hover:fill-white"
        }),
        _createElementVNode("path", {
          d: "M28 36L28 20M28 20L36 28M28 20L20 28",
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          class: "stroke-white transition-colors duration-300 ease-in-out group-hover:stroke-active"
        })
      ], -1)
    ]))], 10, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.total, (i) => {
        return (_openBlock(), _createElementBlock("span", {
          key: i,
          class: _normalizeClass(["w-3 h-3 rounded-full transition-colors cursor-pointer", i - 1 === props.currentIndex ? 'bg-white' : 'bg-white/50']),
          onClick: ($event: any) => (emit('select', i - 1))
        }, null, 10, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('next'))),
      disabled: props.currentIndex === props.total - 1,
      class: _normalizeClass(["group transition-opacity rounded-full hidden md:block", 
        props.currentIndex === props.total - 1
          ? 'opacity-40 cursor-not-allowed'
          : 'opacity-100'
      ])
    }, [...(_cache[3] || (_cache[3] = [
      _createElementVNode("svg", {
        width: "56",
        height: "56",
        viewBox: "0 0 56 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        class: "transition-colors duration-300 ease-in-out"
      }, [
        _createElementVNode("circle", {
          cx: "28",
          cy: "28",
          r: "27.5",
          class: "stroke-white transition-colors duration-300 ease-in-out group-hover:fill-white"
        }),
        _createElementVNode("path", {
          d: "M28 20L28 36M28 36L36 28M28 36L20 28",
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          class: "stroke-white transition-colors duration-300 ease-in-out group-hover:stroke-active"
        })
      ], -1)
    ]))], 10, _hoisted_5)
  ]))
}
}

})